import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", {
  style: {"font-size":"2rem"},
  class: "centered-text"
}, " Welcome to AccidentPlan! ", -1)
const _hoisted_2 = { class: "flex-wrapper flex-centered" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Begin Setup")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _ctx.getStarted,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}